module.exports = __webpack_public_path__ + "img/comment_result.4624ed60.png";